export default function Logo({ className = "", size = 36 }) {
  return (
    <img
      src="/logo.png"
      alt="CLINIT"
      draggable={false}
      style={{ height: Math.round(size * 1.35), width: "auto" }}
      className={className}
    />
  );
}
